import { Skeleton, Stack } from "@mui/material";

export const UserRoleTableSkeleton = () => {
    return (
        <Stack spacing={1}>
            {[...Array(5)].map((_, i) => (
                <Skeleton
                    key={i}
                    animation="wave"
                    variant="rectangular"
                    width="100%"
                    height="2.5em"
                />
            ))}
        </Stack>
    );
};
